<app-main-menu></app-main-menu>
<!-- <div class="menu-board"
  style="display: inline-flex; text-align: center; flex-direction: row; align-items: center;justify-content: center; width: 100%;">
  <app-dashboard-item title="Tìm kiếm" imageLink="assets/images/find.png" backgroundColor="#0277BD" (itemClick)="timKiem($event)">
  </app-dashboard-item>
  <app-dashboard-item title="Thêm hồ sơ" imageLink="assets/images/files.png" backgroundColor="#0277BD" (itemClick)="soCai($event)">
  </app-dashboard-item>
  <app-dashboard-item title="Nhân sự" imageLink="assets/images/users.png" backgroundColor="#0277BD"
    (itemClick)="nhanSu($event)">
  </app-dashboard-item>
</div>
<div class="menu-board"
  style="display: inline-flex; text-align: center; flex-direction: row; align-items: center;justify-content: center; width: 100%;">
  <app-dashboard-item title="Loại hợp đồng" imageLink="assets/images/documents.png" backgroundColor="#0277BD" (itemClick)="loaiHopDong($event)">
  </app-dashboard-item>
  <app-dashboard-item title="Người yêu cầu công chứng" (itemClick)="nguoiYeuCau($event)"
  imageLink="assets/images/info.png" backgroundColor="#0277BD">
  </app-dashboard-item>
  <app-dashboard-item title="Thoát" imageLink="assets/images/logout.png" (itemClick)="logout($event)"
    backgroundColor="#0277BD"></app-dashboard-item>
</div> -->
<div style="width: 100%; background-color: #fdfdfdde;">
  <div style="width:100%;text-align: center; display: inline-flex;flex-direction: row; justify-content: space-around;">
    <app-thongke-title [colorNumber]='soLuongHsThangHienTaiColor' [numberCount]='slTheoThang'
      title="SỐ HỒ SƠ THÁNG HIỆN TẠI" style="display: flex;">
    </app-thongke-title>
    <app-thongke-title [colorNumber]='soLuonghsNamHienTaiColor' [numberCount]='slTheoNam' title="SỐ HỒ SƠ NĂM HIỆN TẠI"
      style="display: flex;"></app-thongke-title>
    <app-thongke-title [colorNumber]='soLuonghsNamTruocColor' [numberCount]='slTheoNamTruoc' title="SỐ HỒ SƠ NĂM TRƯỚC"
      style="display: flex;"></app-thongke-title>
  </div>

  <div style="width: 800px; margin-left: auto; margin-right: auto;">
    <p style="font-family: 'Oswald', sans-serif; font-size: 20px;">Số lượng hồ sơ các tháng trong năm</p>
    <p-divider></p-divider>
    <p-chart type="bar" [data]="dataChart" [options]="optionChart"></p-chart>
  </div>
</div>
<div class="fix-pos bottom-50 pull-left home-green-panel">
  <div style="display: inline-flex;">
    <div>
      <button pButton type="button" icon="fa fa-chevron-right" class="p-button-success"
        (click)="toogleFormThongKe($event)" *ngIf="showFormThongKe"></button>
      <button pButton type="button" icon="fa fa-chevron-left" class="p-button-success"
        (click)="toogleFormThongKe($event)" *ngIf="!showFormThongKe"></button>
      <!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
    </div>
    <div style="width: 100%;margin-left:5px;" *ngIf="showFormThongKe">
      Năm:
      <p-inputNumber [(ngModel)]="tkNamHienTai" [useGrouping]="false"></p-inputNumber>
      <button pButton type="button" label="Thống kê" icon="fa fa-line-chart" class="p-button-success"
        (click)="thongke($event)"></button>
    </div>
  </div>
</div>